import { inject } from 'vue'
import { ApiKey } from '../api/symbols'

export function useApi() {
  const api = inject(ApiKey)
  if (!api) throw new Error('useApi: Api instance not provided. Did you install ApiPlugin?')
  
  return api
}


